export const spacing = Array.from(
  new Map([
    [0, 0],
    [1, 2],
    [2, 4],
    [3, 8],
    [4, 12],
    [5, 16],
    [6, 20],
    [7, 24],
    [8, 32],
    [9, 40],
    [10, 48],
    [11, 60],
  ]).values()
);

export const compactSpacing = spacing.map((it) => it / 2);
